const LIST = [
    {label : '마케팅 서비스', to: '/#/consulting?postType=PT001', src : '/static/img/icon/menu_01.svg' },
    {label : '플레이스순위', to: '/#/placeRank', src : '/static/img/icon/menu_02.svg' },
    {label : '쇼핑순위', to: '/#/shoppingRank', src : '/static/img/icon/menu_03.svg' },
    {label : '대표키워드', to: '/#/keywordsOnce', src : '/static/img/icon/menu_04.svg' },
    {label : '블로그\n방문자수', to: '/#/visitorCheck', src : '/static/img/icon/menu_05.svg' },
    {label : '연관키워드', to: '/#/relateKeywords', src : '/static/img/icon/menu_06.svg' },
    {label : '키워드검색량', to: '/#/searchAmount', src : '/static/img/icon/menu_07.svg' },
    {label : '제휴문의', to: 'http://pf.kakao.com/_QIxlTK', target: '_blank', src : '/static/img/icon/menu_08.svg' },
]

const ShortCut = () => {
    return (
        <section class="section-icon-menu">
            <div class="vw-inner">
                <div class="section-title">
                    <h5>마케팅 도구</h5>
                </div>
                <ul class="icon-menu-list">
                    {LIST.map(( {label, src, to, target = '' }) => (
                        <li>
                            <a href={to} target={target}>
                                <div class="icon-menu-thumb">
                                    <img src={src} />
                                </div>
                                <p>{label}</p>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
        
    )
}

export default ShortCut;